module.exports = __webpack_public_path__ + "e823cb7e370374d65b1495fd8bcc7268.pdf";